<div class="grid-container margin-top">     
    <div class="grid-x grid-margin-x">
        <div class="cell small-12 text-right">
            <button (click)="downloadReport()" class="button">
                Download Report
            </button>
        </div>
    </div>
    <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="activeBonds" aria-label="Bonds Report"></ag-grid-angular>
</div>

